/**
* functions common cookie
*
* @category   Javascript
* @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
* @copyright  2025 Jakob Ohlsen
*/
export function setCookie(key, value, ttl) {
    const d = new Date();
    d.setTime(d.getTime() + ttl);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${key}=${value};${expires};path=/;SameSite=Lax`;
}
export function getCookie(key) {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}
export function removeCookie(key) {
    document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
}
